export default __webpack_public_path__ + "static/media/current-position.c210baed.svg";